export { default } from './InfoMaterialContent';



// WEBPACK FOOTER //
// ./src/components/InfoMaterials/InfoMaterialContent/index.js